import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'utcDate'
})
export class UtcDatePipe implements PipeTransform {
  transform(value: string | null | undefined, format: string = 'd MMM y, hh:mm a'): string {
    if (!value) return '----';
    const hasTimezone = value.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(value);
    const normalized = hasTimezone ? value : value + 'Z';
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return formatDate(normalized, format, 'en-US', timezone);
  }
}
